module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-text-field', {
    attrs: {
      "min": 0,
      "inputClass": "currencyInput",
      "hintText": 'Enter in ' + _vm.currency.currencyCode,
      "helpText": _vm.displayValue + ' ' + _vm.$t('message.labelPerWeek'),
      "label": _vm.label,
      "type": _vm.castingType,
      "fullWidth": true
    },
    on: {
      "blur": function($event) {
        _vm.isInputActive = false
      },
      "focus": function($event) {
        _vm.isInputActive = true
      },
      "change": function($event) {
        return _vm.changed()
      }
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = _vm._n($$v)
      },
      expression: "inputValue"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-330fa055","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/directives/CurrencyInput.vue
// module id = 3670
// module chunks = 1